import { render, staticRenderFns } from "./RoomView.vue?vue&type=template&id=ce882002&scoped=true"
import script from "./RoomView.vue?vue&type=script&lang=js"
export * from "./RoomView.vue?vue&type=script&lang=js"
import style0 from "./RoomView.vue?vue&type=style&index=0&id=ce882002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce882002",
  null
  
)

export default component.exports